import Vue from 'vue'
import VueRouter from 'vue-router'
import { isUserLoggedIn, getUserData } from '@/auth/utils'
import authRouter from './auth'
import eventsRouter from './events'
import companyRouter from './company'
import salesRouter from './sales'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...authRouter,
    ...eventsRouter,
    ...companyRouter,
    ...salesRouter,
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomePage.vue'),
      meta: {
        pageTitle: 'Anasayfa',
        pageIcon: 'HomeIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Anasayfa',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login/:type?',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        goHome: true,
        layout: 'full',
      },
    },
    {
      path: '/manage/customers/used',
      name: 'customers-used',
      component: () => import('@/views/manage/CustomersUsed.vue'),
      meta: {
        // menuHidden: true,
        pageIcon: 'UsersIcon',
        breadcrumb: [
          {
            text: 'Kullanımlar',
            active: true,
          },
        ],
      },
    },
    {
      path: '/customers/used/events',
      name: 'customers-used-events',
      component: () => import('@/views/manage/CustomersEventsUsed.vue'),
      meta: {
        pageIcon: 'ActivityIcon',
        breadcrumb: [
          {
            text: 'Events Kullanımı',
            active: true,
          },
        ],
      },
    },
    {
      path: '/manage/customers',
      name: 'customers',
      component: () => import('@/views/manage/Customers.vue'),
      meta: {
        // menuHidden: true,
        pageIcon: 'UsersIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Müşteri Listesi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/manage/customer/:id',
      name: 'customer-card',
      component: () => import('@/views/manage/CustomerCard.vue'),
      meta: {
        // menuHidden: true,
        pageIcon: 'UsersIcon',
        navActiveLink: 'customers',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Müşteriler',
            to: {'name':'customers'}
          },
          {
            text: 'Müşteri Detay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/manage/test-runner',
      name: 'test-runner',
      component: () => import('@/views/manage/TestRunner.vue'),
      meta: {
        // menuHidden: true,
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Test Runner',
            active: true,
          },
        ],
      },
    },
    {
      path: '/manage/domains',
      name: 'domains',
      component: () => import('@/views/manage/DomainList.vue'),
      meta: {
        // menuHidden: true,
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Domain Yönetimi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/influencers',
      name: 'influencers',
      component: () => import('@/views/Influencers.vue'),
      meta: {
        pageTitle: 'Influencer',
        pageIcon: 'UsersIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Influencer Listesi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/influencer/:id',
      name: 'influencer-detail',
      component: () => import('@/views/users-edit/UsersEdit.vue'),
      meta: {
        pageTitle: 'Influencer',
        pageIcon: 'AwardIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Influencer Detay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/influencer/detail/:id',
      name: 'influencer-card',
      component: () => import('@/views/InfluencerCard.vue'),
      meta: {
        pageTitle: 'Influencer',
        pageIcon: 'AwardIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Influencer Detay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/:id',
      name: 'admin-detail',
      component: () => import('@/views/users-edit/UsersEdit.vue'),
      meta: {
        pageTitle: 'Yönetim',
        pageIcon: 'UsersIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Kullanıcı Detay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admins',
      name: 'admins',
      component: () => import('@/views/Admins.vue'),
      meta: {
        pageTitle: 'Yönetim',
        pageIcon: 'UsersIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Kullanıcı Listesi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('@/views/Products.vue'),
      meta: {
        pageTitle: 'Ürünler',
        pageIcon: 'LinkIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Ürün Listesi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/setup',
      name: 'setup',
      component: () => import('@/views/Setup.vue'),
      meta: {
        pageTitle: 'Ayarlar',
        pageIcon: 'CodeIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Setup',
            active: true,
          },
        ],
      },
    },
    {
      path: '/campaign/:type',
      name: 'campaign',
      component: () => import('@/views/campaign/CampaignList.vue'),
      meta: {
        pageTitle: 'Paylaşım',
        pageIcon: 'DollarSignIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Listesi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/campaign/detail/:id',
      name: 'campaign-detail',
      component: () => import('@/views/campaign/CampaignDetail.vue'),
      meta: {
        navActiveLink: 'campaign',
        pageTitle: 'Paylaşımlar',
        pageIcon: 'DollarSignIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Paylaşım Detay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/campaign/group-detail/:id',
      name: 'campaign-group-detail',
      component: () => import('@/views/campaign/CampaignGroupDetail.vue'),
      meta: {
        navActiveLink: 'campaign',
        pageTitle: 'Paylaşımlar',
        pageIcon: 'DollarSignIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Toplu Paylaşım',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vesting/:id?',
      name: 'vesting',
      component: () => import('@/views/vesting/Vesting.vue'),
      meta: {
        pageTitle: 'Hakedişler',
        pageIcon: 'DollarSignIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Raporlar',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vesting/payment/:id?',
      name: 'vesting-payment',
      component: () => import('@/views/vesting/VestingPayment.vue'),
      meta: {
        pageTitle: 'Hakedişler',
        pageIcon: 'BriefcaseIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Ödemeler',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analysis/product',
      name: 'analysis-product',
      component: () => import('@/views/analysis/Product.vue'),
      meta: {
        pageTitle: 'Analiz',
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Ürün',
            active: true,
          },
        ],
      },
    },
    
    {
      path: '/analysis/fenomen',
      name: 'analysis-fenomen',
      component: () => import('@/views/analysis/Influencer.vue'),
      meta: {
        pageTitle: 'Analiz',
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Fenomenler',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analysis/multi-links',
      name: 'analysis-multi-links',
      component: () => import('@/views/analysis/MultiLinks.vue'),
      meta: {
        pageTitle: 'Analiz',
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Kampanya',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analysis/:type',
      name: 'analysis-links',
      component: () => import('@/views/analysis/Story.vue'),
      meta: {
        pageTitle: 'Analiz',
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
        breadcrumb: [
          {
            text: 'Paylaşımlar',
            active: true,
          },
        ],
      },
    },
    {
      path: '/utm-settings',
      name: 'utm-setting',
      component: () => import('@/views/UtmSettings.vue'),
      meta: {
        pageTitle: 'Utm Ayarları',
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/Settings.vue'),
      meta: {
        pageTitle: 'Ayarlar',
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
      },
    },
    {
      path: '/developer-notes',
      name: 'developer-notes',
      component: () => import('@/views/DeveloperNotes.vue'),
      meta: {
        pageTitle: 'Geliştirme Notları',
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
      },
    },
    {
      path: '/platforms',
      name: 'platforms',
      component: () => import('@/views/Platforms.vue'),
      meta: {
        pageTitle: 'Platformlar',
        pageIcon: 'ScissorsIcon',
        requiresAuth : true,
      },
    },
    {
      path: '/link-types',
      name: 'link-types',
      component: () => import('@/views/LinkTypes.vue'),
      meta: {
        pageTitle: 'Link Tipleri',
        pageIcon: 'LinkIcon',
        requiresAuth : true,
      },
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/help/Help.vue'),
      meta: {
        pageTitle: 'Yardım Merkezi',
        pageIcon: 'HelpCircleIcon',
        requiresAuth : true,
      },
    },
    {
      path: '/permissions',
      name: 'permissions',
      component: () => import('@/views/Permissions.vue'),
      meta: {
        pageTitle: 'İzin Yönetimi',
        pageIcon: 'HelpCircleIcon',
        requiresAuth : true,
      },
    },
    {
      path: '/package/price',
      name: 'price',
      component: () => import('@/views/package/Price.vue'),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: '/logs',
      name: 'logs',
      component: () => import('@/views/Logs.vue'),
      meta: {
        requiresAuth : true,
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/no-access',
      name: 'no-access',
      component: () => import('@/views/error/NoAccess.vue'),
      meta: {
        pageTitle: 'Erişim Yok',
        pageIcon: 'ActivityIcon',
        requiresAuth : true,
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!isLoggedIn && to.meta.requiresAuth) {
    next({ path: '/login' })
  } else if (isLoggedIn && to.meta.goHome === true) {
    next('/')
  } else {
    next()
  }
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
